import { createTheme } from '@mui/material/styles'
import { finalConfig } from "src/configs/styles/management";
import { deepmerge } from '@mui/utils'

const theme = createTheme({
  palette: {
    ...deepmerge(finalConfig, {
      rank: {
        none: '#BDBDBD'
      }
    })
  },
  typography: {
    allVariants: {
      whiteSpace: 'pre-line',
    },
  }
})

export default theme
